function skill()
{
    return(
      <section id="skill">
        <h2>Skill</h2>
        <ul>
            <li>React</li>
            <li>Javascrpit(Es6+)</li>
            <li>HTML/CSS</li>
            <li>Node.js</li>
            <li>MongoDb/MySQL</li>
            <li>Python</li>
            <li>Wordpress(Elementor,Avada)</li>
            <li>Tkintor(GUI development with puthon)</li>


        </ul>
      </section>  
    );
}export default skill;